import React from "react";
import { Link } from "react-router-dom";

// animation importation
// import Fade from "react-reveal/Fade";
import styled from "styled-components";
// import Head from "../Components/Head";

function NoMatch() {
  return (
    <>
      {/* <Head title="Page Not Found " /> */}
      {/* <Fade> */}
      <Container>
        <h1>
          lost!
          <br />
          Wanna back to <Link to="/">Home</Link>!{" "}
        </h1>
      </Container>
      {/* <div className="lostpage backG">
          <img src="/notfound.webp" alt="" />
        </div> */}
      {/* </Fade> */}
    </>
  );
}
const Container = styled.main`
  background-image: url("/image/404.svg");
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 400px;
  width: 100vw;
  background-color: var(--aliceblue);
  height: 100vh;
  @media (max-width: 548px) {
    background-size: 200px;
    background-position: center;
    align-items: center;
  }
  display: flex;
  justify-content: center;
  align-items: flex-end;
  h1 {
    text-align: center;
    margin-bottom: 100px;
    z-index: 200;
    @media (max-width: 548px) {
      margin-bottom: 0;
      background-color: var(--white-transparent);
    }
  }
`;

export default NoMatch;
